import { render, staticRenderFns } from "./readEdAndSignDialog.vue?vue&type=template&id=4cbb1987&scoped=true&"
import script from "./readEdAndSignDialog.vue?vue&type=script&lang=js&"
export * from "./readEdAndSignDialog.vue?vue&type=script&lang=js&"
import style0 from "./readEdAndSignDialog.vue?vue&type=style&index=0&id=4cbb1987&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cbb1987",
  null
  
)

export default component.exports